import React from 'react'
import style from '../../scss/components/common/_loader.module.scss'

export default function Loader() {
  return (

        <span className={style.loader}></span>

  )
}
